export default function ContactSection() {
  return (
    <section className="w-full py-24 md:py-32 px-10 md:px-16 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row gap-16 lg:gap-24">
        <div className="w-full lg:w-[40%] flex flex-col">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Get In
            <br />
            Touch
          </h2>

          <p className="mt-6 text-base text-foreground-500 leading-relaxed max-w-sm">
            We are based in Toronto, Canada. Reach out to discuss how we can help bring your next project to life with engineering excellence.
          </p>

          <div className="mt-14 space-y-5">
            <div>
              <p className="text-sm text-foreground-400 uppercase tracking-widest font-medium">Address</p>
              <p className="mt-2 text-base text-foreground-700 leading-relaxed">
                475 Salem Avenue North, Apartment 10
                <br />
                Toronto, M6H 3C9
                <br />
                Canada
              </p>
            </div>
            <div>
              <p className="text-sm text-foreground-400 uppercase tracking-widest font-medium">Phone</p>
              <p className="mt-2 text-base text-foreground-700">+1 2493155173</p>
            </div>
            <div>
              <p className="text-sm text-foreground-400 uppercase tracking-widest font-medium">Email</p>
              <p className="mt-2 text-base text-foreground-700">ceo@rmsssoftware.com</p>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[60%]">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 lg:gap-16">
            <div>
              <p className="text-sm text-foreground-400 uppercase tracking-widest font-medium mb-4">Address</p>
              <p className="text-base text-foreground-700 leading-relaxed">
                475 Salem Avenue North
                <br />
                Apartment 10
              </p>
              <p className="mt-4 text-base text-foreground-700">
                Toronto
              </p>
            </div>
            <div>
              <p className="text-sm text-foreground-400 uppercase tracking-widest font-medium mb-4">Location</p>
              <p className="text-base text-foreground-700">
                M6H 3C9
              </p>
              <p className="mt-4 text-base text-foreground-700">
                Canada
              </p>
            </div>
            <div>
              <p className="text-sm text-foreground-400 uppercase tracking-widest font-medium mb-4">Contact</p>
              <p className="text-base text-foreground-700">
                +1 2493155173
              </p>
              <p className="mt-4 text-base text-foreground-700">
                ceo@rmsssoftware.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}